module.exports = __webpack_public_path__ + "img/23.3533b48b.jpg";